/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StaySafeNotificationPreferences,
    StaySafeNotificationPreferencesFromJSON,
    StaySafeNotificationPreferencesFromJSONTyped,
    StaySafeNotificationPreferencesToJSON,
} from './StaySafeNotificationPreferences';

/**
 * 
 * @export
 * @interface UserNotificationPreferences
 */
export interface UserNotificationPreferences {
    /**
     * 
     * @type {Array<StaySafeNotificationPreferences>}
     * @memberof UserNotificationPreferences
     */
    staySafe: Array<StaySafeNotificationPreferences>;
}

export function UserNotificationPreferencesFromJSON(json: any): UserNotificationPreferences {
    return UserNotificationPreferencesFromJSONTyped(json, false);
}

export function UserNotificationPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserNotificationPreferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'staySafe': ((json['stay_safe'] as Array<any>).map(StaySafeNotificationPreferencesFromJSON)),
    };
}

export function UserNotificationPreferencesToJSON(value?: UserNotificationPreferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stay_safe': ((value.staySafe as Array<any>).map(StaySafeNotificationPreferencesToJSON)),
    };
}

